import { createSlice } from '@reduxjs/toolkit';

export const siteSlice = createSlice({
    name:'site',
    initialState:{
       layout:''
    },
    reducers:{
        setLayout:(state,action)=>{
            state.layout=action.payload
        }

    }
})
export const{ setLayout}=siteSlice.actions;

export default siteSlice.reducer;
export const AdminTitle = ({title}) => (
    <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom'>
        <h1 className='h2'>{title}</h1>
    </div>
)




